import React, { createContext, useReducer } from "react";

import { BaseState } from "./CommonContextTypes";
import Paginator from "../models/Paginator";
import User from "../models/User";
import Business from "../models/Business";

interface ICIPAdminState extends BaseState {
  init: boolean;
  error: string;

  // Businesses tab
  businesses?: Paginator;
  business?: Business | null;
  // Users tab
  users?: Paginator;
  user?: User | null;
}

export enum ICIPAdminActionTypeEnum {
  init,
  error,
  loading,
  loaded,
  store,
}

interface ICIPAdminAction {
  type: ICIPAdminActionTypeEnum;
  data?: any;
}

export const ICIPAdminContext = createContext<ICIPAdminState>(initState());
ICIPAdminContext.displayName = "ICIP admin context";
export const ICIPAdminDispatchContext = createContext<Function>(() => {});
ICIPAdminContext.displayName = "ICIP admin dispatch context";

function ICIPAdminReducer(
  state: ICIPAdminState,
  action: ICIPAdminAction
): ICIPAdminState {
  switch (action.type) {
    case ICIPAdminActionTypeEnum.init:
      return { ...state, init: true, loading: false, error: undefined };
    case ICIPAdminActionTypeEnum.error:
      return {
        ...state,
        init: false,
        loading: false,
        error: action.data.error,
        ...action.data,
      };
    case ICIPAdminActionTypeEnum.loading:
      return { ...state, init: false, loading: true, error: undefined };
    case ICIPAdminActionTypeEnum.loaded:
      return { ...state, init: false, loading: false, error: undefined };
    case ICIPAdminActionTypeEnum.store:
      return {
        ...state,
        ...action.data,
        loading: false,
        init: false,
      };
    default:
      return state;
  }
}

export const ICIPAdminProvider: React.FC = ({ children }) => {
  const [state, dispatch] = useReducer(ICIPAdminReducer, initState());

  return (
    <ICIPAdminContext.Provider value={state}>
      <ICIPAdminDispatchContext.Provider value={dispatch}>
        {children}
      </ICIPAdminDispatchContext.Provider>
    </ICIPAdminContext.Provider>
  );
};

function initState(): ICIPAdminState {
  return {
    init: false,
    error: undefined,
    loading: false,
    businesses: null,
    users: null,
    business: null,
    user: null,
  };
}

export function updatePaginator(
  oldPaginator: Paginator,
  newValue: Business | User
): Paginator {
  let newPaginator: Paginator = oldPaginator.clone();

  newPaginator.items = oldPaginator.items.map((item: User | Business) => {
    if (item.id === newValue.id) {
      return newValue;
    }

    return item;
  });

  return newPaginator;
}
